import React from 'react'
import PropTypes from 'prop-types'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from '@material-ui/pickers'

export default function InputHour(props) {
  const {
    value,
    label,
    id,
    onChange,
    name,
  } = props

  const handleChange = (datetime) => {
    onChange({ name, datetime })
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardTimePicker
        name={name}
        margin="normal"
        id={id}
        label={label}
        value={value}
        onChange={handleChange}
        KeyboardButtonProps={{
          'aria-label': 'alterar hora',
        }}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </MuiPickersUtilsProvider>
  )
}

InputHour.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
}

InputHour.defaultProps = {
  label: 'Hora',
  value: new Date(),
}
